import { Button } from "../components/core/basic/Button";
import SellerChannel from "../components/custom/navbar/SellerChannel";
import SellerMarketplace from "../components/custom/navbar/SellerMarketplace";
import SellerAccount from "../components/custom/navbar/SellerAccount";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "@tanstack/react-router";
import { Navbar } from "react-bootstrap";
import { connect } from "react-redux";
import { logoutUser } from "../redux/reducers/userReducer";
import { useMediaQuery } from "@reactuses/core";
import NotificationProvider from "../notifications/NotificationProvider";
import { NotificationContext } from "../notifications/NotificationContext";
import NotificationDropdown from "../components/custom/navbar/NotificationDropdown";
import { selectModules } from "../redux/selectors/modules";
import Search from "../components/custom/navbar/Search";
import { HStack } from "../../styled-system/jsx";
import { css, cx } from "../../styled-system/css";
import { hstack } from "../../styled-system/patterns";
import TodayButton from "../modules/merchandising/components/TodayButton";
import { useModuleEnabled } from "../redux/selectors/modules";
import Chat from "../components/chat/Chat";
import { DatesProvider } from "../dates/DatesContext";
import { CompletedVideoGenerationRequestsWidget } from "../components/custom/video-generation/CompletedVideoGenerationRequestsWidget";
import { SUPPORTED_VIDEO_GEN_MARKETPLACES } from "../components/custom/video-generation/constants";

const NavigationBar = (props) => {
  const matches = useMediaQuery("only screen and (min-width: 992px)");
  const location = useLocation();
  const [showContent, setShowContent] = useState(matches);
  const [showNotifications, setShowNotifications] = useState(false);
  const hasChatModule = useModuleEnabled("CHAT");
  const { t } = useTranslation(["common"]);

  // Close notification dropdown on url update
  useEffect(() => {
    setShowNotifications(false);
  }, [location]);

  // function for responsive that hides/shows the sidebar
  const mobileSidebarToggle = () => {
    document.documentElement.classList.toggle("nav-open");
    setShowContent(!showContent);
  };

  const onLogoutClick = () => {
    props.logoutUser();
  };

  return (
    <NotificationProvider>
      <NotificationContext.Consumer>
        {({ notifications, isLoading }) => {
          return (
            <Navbar
              className={cx(
                "navbar-default",
                css({
                  height: "75px",
                  paddingX: "large",
                  flexWrap: "nowrap",
                  justifyContent: "end",
                  gap: "large",
                }),
              )}
              expand="lg"
            >
              {/* Here we import the links that appear in navbar */}
              {matches ?
                <Navbar.Collapse className={hstack({ justifyContent: "space-between" })}>
                  <HStack justifyContent={"start"} flex={"0 0"} gap="xsmall">
                    <SellerChannel />
                    <SellerAccount />
                    <SellerMarketplace />
                  </HStack>

                  {matches ?
                    <Search />
                  : null}

                  <HStack>
                    {hasChatModule && (
                      <DatesProvider>
                        <Chat />
                      </DatesProvider>
                    )}
                    {SUPPORTED_VIDEO_GEN_MARKETPLACES.includes(props.marketPlace.marketPlace) && (
                      <CompletedVideoGenerationRequestsWidget />
                    )}
                    {props.channel.currentChannel === "amazon" && <TodayButton />}

                    <Button onPress={onLogoutClick}>{t(($) => $.common.Logout)}</Button>
                  </HStack>
                </Navbar.Collapse>
              : props.notificationsEnabled && (
                  <div
                    onClick={() => {
                      setShowNotifications(!showNotifications);
                    }}
                    className={css({
                      cursor: "pointer",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      padding: "1rem",
                      border: `2px solid {colors.trellisPalette.6}`,
                      borderRadius: "99999999999px",
                      color: "trellisPalette.6",
                      flex: "0 0",
                    })}
                  >
                    <i className="fa fa-bell" />
                    <span>{notifications && notifications.length}</span>
                  </div>
                )
              }
              <Navbar.Toggle onClick={mobileSidebarToggle} aria-controls="basic-navbar-nav" />
              {showNotifications && (
                <NotificationDropdown
                  showNotifications={showNotifications}
                  setShowNotifications={setShowNotifications}
                  notifications={notifications}
                  isLoading={isLoading}
                />
              )}
            </Navbar>
          );
        }}
      </NotificationContext.Consumer>
    </NotificationProvider>
  );
};

const mapStateToProps = (state) => ({
  marketPlace: state.marketPlace,
  channel: state.channel,
  modules: selectModules(state),
  notificationsEnabled:
    state.user.preferences?.all_notifications ||
    // NOTE: Line below will need to be removed once default value is added to db for all users
    // Currently used for missing all_notifications in preferences column
    typeof state.user.preferences?.all_notifications === "undefined" ||
    state.user.preferences?.ad_product_out_of_stock ||
    state.user.preferences?.ad_product_low_in_stock ||
    state.user.preferences?.product_ineligibility ||
    state.user.preferences?.product_exceed_spend,
});

const mapDispatchToProps = {
  logoutUser,
};

export default connect(mapStateToProps, mapDispatchToProps)(NavigationBar);
